import { Flex, ProgressCircle } from "@/components/wrappers/Spectrum/SpectrumWrapper.tsx"

export const LoadingFallback = () => (
  <Flex alignItems="center" justifyContent="center" height="100%" width="100%">
    <ProgressCircle size="L" aria-label="Loading content" isIndeterminate />
  </Flex>
)